import axios from "axios";
import { BaseURL } from "../../Essentials/variables";

const api = axios.create({
  baseURL: BaseURL
});

/**
 * Get ADFS login redirect URL from backend
 */

export const getADFSLoginUrl = async () => {
  try {
    const response = await api.get("/federation", {
      params: { type: "login" }
    });
    if (!response || !response.data) {
      throw new Error("Empty response from login API");
    }

    const redirectUrl = response.data?.data;

    if (!redirectUrl || typeof redirectUrl !== "string") {
      throw new Error("Invalid redirect URL received");
    }

    return redirectUrl;
  } catch (error) {
    throw new Error("Unable to initiate login");
  }
};

/**
 * Get ADFS logout redirect URL from backend
 */

export const getADFSLogoutUrl = async () => {
  try {

    const response = await api.get("/federation", {
      params: { type: "logout" }
    });
    if (!response || !response.data) {
      throw new Error("Empty response from logout API");
    }

    const redirectUrl = response.data?.data;

    if (!redirectUrl || typeof redirectUrl !== "string") {
      throw new Error("Invalid logout URL received");
    }

    return redirectUrl;
  } catch (error) {
    throw new Error("Unable to initiate logout");
  }
};

export const getADFSTokenUrl = async (code) => {
  try {
    const response = await api.get("/federation", {
      params: { code }
    });
    if (!response || !response.data) {
      throw new Error("Empty response from logout API");
    }
    const resposeData = response.data?.data;
    //console.error(resposeData?.IdToken);
    const token = resposeData?.IdToken;

    if (!token) {
      throw new Error("Invalid token received");
    }


    return resposeData;
  } catch (error) {
    throw new Error("Unable to get Token");
  }
};

